import { VoiceCode } from './voice-code';

export interface ProjectLanguage {
  lang_code: string,
  lang_name: string,
  lang_name_en: string,
  display_name: string,
  trans_lang_code: string,
  tts_lang_code: string,
  tts_voice_code: VoiceCode
}

export class ProjectLanguageClass {
  project_language!:ProjectLanguage

  constructor(
    project_language:ProjectLanguage
  ) {
    this.project_language = project_language;
  }

  dispLang(lang: string): string {
    if (lang === 'ja') {
      return this.project_language.lang_name;
    } else if (lang === 'en') {
      return this.project_language.lang_name_en;
    } else {
      return '';
    }
  }
}